import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IMiPrelimFooter } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-mi-invoice-footer',
  standalone: true,
  imports: [CurrencyPipe],
  templateUrl: './mi-invoice-footer.component.html',
  styleUrl: './mi-invoice-footer.component.scss',
})
export class MiInvoiceFooterComponent {
  @Input() miFooterData: IMiPrelimFooter;
}
